module.exports = __webpack_public_path__ + "static/neon-82c9596f1d3ecc04bbf712c69e29cfa0.png";